function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Plugin } from '@ckeditor/ckeditor5-core/dist/index.js';
import { Template, View } from '@ckeditor/ckeditor5-ui/dist/index.js';
import { env } from '@ckeditor/ckeditor5-utils/dist/index.js';
import { throttle, isElement } from 'lodash-es';
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
* @module word-count/utils
*/

/**
* Returns a plain text representation of an element and its children.
*
* @returns Plain text representing the model's data.
*/

function modelElementToPlainText(item) {
  if (item.is('$text') || item.is('$textProxy')) {
    return item.data;
  }

  var element = item;
  var text = '';
  var prev = null;

  var _iterator = _createForOfIteratorHelper(element.getChildren()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;
      var childText = modelElementToPlainText(child); // If last block was finish, start from new line.

      if (prev && prev.is('element')) {
        text += '\n';
      }

      text += childText;
      prev = child;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return text;
}
/**
 * The word count plugin.
 *
 * This plugin calculates all words and characters in all {@link module:engine/model/text~Text text nodes} available in the model.
 * It also provides an HTML element that updates its state whenever the editor content is changed.
 *
 * The model's data is first converted to plain text using {@link module:word-count/utils~modelElementToPlainText}.
 * The number of words and characters in your text are determined based on the created plain text. Please keep in mind
 * that every block in the editor is separated with a newline character, which is included in the calculation.
 *
 * Here are some examples of how the word and character calculations are made:
 *
 * ```html
 * <paragraph>foo</paragraph>
 * <paragraph>bar</paragraph>
 * // Words: 2, Characters: 7
 *
 * <paragraph><$text bold="true">foo</$text>bar</paragraph>
 * // Words: 1, Characters: 6
 *
 * <paragraph>*&^%)</paragraph>
 * // Words: 0, Characters: 5
 *
 * <paragraph>foo(bar)</paragraph>
 * //Words: 1, Characters: 8
 *
 * <paragraph>12345</paragraph>
 * // Words: 1, Characters: 5
 * ```
 */


var WordCount = /*#__PURE__*/function (_Plugin) {
  _inherits(WordCount, _Plugin);

  var _super = _createSuper(WordCount);

  /**
  * The configuration of this plugin.
  */

  /**
  * The reference to a {@link module:ui/view~View view object} that contains the self-updating HTML container.
  */

  /**
  * A regular expression used to recognize words in the editor's content.
  */

  /**
  * @inheritDoc
  */
  function WordCount(editor) {
    var _this;

    _classCallCheck(this, WordCount);

    _this = _super.call(this, editor);
    _this._config = void 0;
    _this._outputView = void 0;
    _this._wordsMatchRegExp = void 0;

    _this.set('characters', 0);

    _this.set('words', 0); // Don't wait for the #update event to set the value of the properties but obtain it right away.
    // This way, accessing the properties directly returns precise numbers, e.g. for validation, etc.
    // If not accessed directly, the properties will be refreshed upon #update anyway.


    Object.defineProperties(_assertThisInitialized(_this), {
      characters: {
        get: function get() {
          return this.characters = this._getCharacters(this._getText());
        }
      },
      words: {
        get: function get() {
          return this.words = this._getWords(this._getText());
        }
      }
    });

    _this.set('_wordsLabel', undefined);

    _this.set('_charactersLabel', undefined);

    _this._config = editor.config.get('wordCount') || {};
    _this._outputView = undefined;
    _this._wordsMatchRegExp = env.features.isRegExpUnicodePropertySupported ? // Usage of regular expression literal cause error during build (ckeditor/ckeditor5-dev#534).
    // Groups:
    // {L} - Any kind of letter from any language.
    // {N} - Any kind of numeric character in any script.
    new RegExp('([\\p{L}\\p{N}]+\\S?)+', 'gu') : /([0-9A-Za-z\xC0-\u017E]+(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])?)+/g;
    return _this;
  }
  /**
  * @inheritDoc
  */


  _createClass(WordCount, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var _this2 = this;

      var editor = this.editor;
      editor.model.document.on('change:data', throttle(this._refreshStats.bind(this), 250));

      if (typeof this._config.onUpdate == 'function') {
        this.on('update', function (evt, data) {
          _this2._config.onUpdate(data);
        });
      }

      if (isElement(this._config.container)) {
        this._config.container.appendChild(this.wordCountContainer);
      }
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this._outputView) {
        this._outputView.element.remove();

        this._outputView.destroy();
      }

      _get(_getPrototypeOf(WordCount.prototype), "destroy", this).call(this);
    }
    /**
    * Creates a self-updating HTML element. Repeated executions return the same element.
    * The returned element has the following HTML structure:
    *
    * ```html
    * <div class="ck ck-word-count">
    * 	<div class="ck-word-count__words">Words: 4</div>
    * 	<div class="ck-word-count__characters">Characters: 28</div>
    * </div>
    * ```
    */

  }, {
    key: "wordCountContainer",
    get: function get() {
      var editor = this.editor;
      var t = editor.t;
      var displayWords = editor.config.get('wordCount.displayWords');
      var displayCharacters = editor.config.get('wordCount.displayCharacters');
      var bind = Template.bind(this, this);
      var children = [];

      if (!this._outputView) {
        this._outputView = new View();

        if (displayWords || displayWords === undefined) {
          this.bind('_wordsLabel').to(this, 'words', function (words) {
            return t('Words: %0', words);
          });
          children.push({
            tag: 'div',
            children: [{
              text: [bind.to('_wordsLabel')]
            }],
            attributes: {
              class: 'ck-word-count__words'
            }
          });
        }

        if (displayCharacters || displayCharacters === undefined) {
          this.bind('_charactersLabel').to(this, 'characters', function (words) {
            return t('Characters: %0', words);
          });
          children.push({
            tag: 'div',
            children: [{
              text: [bind.to('_charactersLabel')]
            }],
            attributes: {
              class: 'ck-word-count__characters'
            }
          });
        }

        this._outputView.setTemplate({
          tag: 'div',
          attributes: {
            class: ['ck', 'ck-word-count']
          },
          children: children
        });

        this._outputView.render();
      }

      return this._outputView.element;
    }
  }, {
    key: "_getText",
    value: function _getText() {
      var txt = '';

      var _iterator2 = _createForOfIteratorHelper(this.editor.model.document.getRoots()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var root = _step2.value;

          if (txt !== '') {
            // Add a delimiter, so words from each root are treated independently.
            txt += '\n';
          }

          txt += modelElementToPlainText(root);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return txt;
    }
    /**
    * Determines the number of characters in the current editor's model.
    */

  }, {
    key: "_getCharacters",
    value: function _getCharacters(txt) {
      return txt.replace(/\n/g, '').length;
    }
    /**
    * Determines the number of words in the current editor's model.
    */

  }, {
    key: "_getWords",
    value: function _getWords(txt) {
      var detectedWords = txt.match(this._wordsMatchRegExp) || [];
      return detectedWords.length;
    }
    /**
    * Determines the number of words and characters in the current editor's model and assigns it to {@link #characters} and {@link #words}.
    * It also fires the {@link #event:update}.
    *
    * @fires update
    */

  }, {
    key: "_refreshStats",
    value: function _refreshStats() {
      var txt = this._getText();

      var words = this.words = this._getWords(txt);

      var characters = this.characters = this._getCharacters(txt);

      this.fire('update', {
        words: words,
        characters: characters
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return 'WordCount';
    }
  }]);

  return WordCount;
}(Plugin);

export { WordCount };